/* eslint-disable react/no-did-update-set-state */

import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import DateRangePickerActual from './DateRangePickerActual';
import isBeforeDay from './utils/isBeforeDay';

import {
    START_DATE,
    END_DATE
} from './constants';

export default class DateRangePicker extends React.PureComponent {
    static propTypes = {
        startDateId: PropTypes.string,
        endDateId: PropTypes.string,
        startDateAriaLabel: PropTypes.string,
        endDateAriaLabel: PropTypes.string
    };

    static defaultProps = {
        startDateId: START_DATE,
        endDateId: END_DATE,
        startDateAriaLabel: 'Check in',
        endDateAriaLabel: 'Check out'
    };

    state = {
        startDateError: null,
        endDateError: null
    };

    componentDidUpdate() {
        // Validation error here is for isRequired only and it's only
        // a moment in time. So we reset it once the component updates and
        // let the internal component takeover the validation state.
        if (this.state.startDateError || this.state.endDateError) {
            this.setState({
                startDateError: null,
                endDateError: null
            });
        }
    }

    validate = () => {
        const {
            startDate,
            endDate,
            isOutsideRange,
            isDayBlocked,
            minimumNights,
            required,
            isRequired,
            startDateId,
            endDateId,
            startDateAriaLabel,
            endDateAriaLabel
        } = this.props;

        const validationState = {
            isInvalid: false,
            errorText: null,
            id: startDateId
        };

        if (isRequired || required) {
            const startDateError = startDate ? null : 'is required';
            const endDateError = endDate ? null : 'is required';

            if (startDateError) {
                this.setState({
                    startDateError,
                    endDateError
                });

                validationState.isInvalid = true;
                validationState.errorText = `${startDateAriaLabel} and ${endDateAriaLabel} are required.`;
            }
            if (!startDateError && endDateError) {
                this.setState({
                    startDateError,
                    endDateError
                });

                validationState.isInvalid = true;
                validationState.id = endDateId;
                validationState.errorText = `${endDateAriaLabel} is required.`;
            }

            if (startDateError || endDateError) {
                return validationState;
            }
        }

        if (startDate && moment.isMoment(startDate)) {
            let isStartDateInvalid = false;

            if (isOutsideRange) {
                isStartDateInvalid = isOutsideRange(startDate)
            }
            if (!isStartDateInvalid && isDayBlocked) {
                isStartDateInvalid = isDayBlocked(startDate);
            }

            if (isStartDateInvalid) {
                validationState.isInvalid = true;
                validationState.errorText = `${startDateAriaLabel} is not available.`;
                return validationState;
            }
        }

        if (endDate && moment.isMoment(endDate)) {
            const isEndDateBeforeStartDate = isBeforeDay(endDate, startDate.clone().add(minimumNights, 'days'));
            let isEndDateInvalid = false;

            if (isOutsideRange) {
                isEndDateInvalid = isOutsideRange(startDate)
            }
            if (!isEndDateInvalid && isDayBlocked) {
                isEndDateInvalid = isDayBlocked(startDate);
            }

            if (isEndDateInvalid) {
                validationState.isInvalid = true;
                validationState.id = endDateId;
                validationState.errorText = `${endDateAriaLabel} is not valid.`;
                return validationState;
            }

            if (isEndDateBeforeStartDate) {
                validationState.isInvalid = true;
                validationState.id = endDateId;
                validationState.errorText = `${endDateAriaLabel} is not valid`;
                return validationState;
            }
        }

        // It's valid
        if (this.state.startDateError || this.state.endDateError) {
            this.setState({
                startDateError: null,
                endDateError: null
            });
        }

        return validationState;
    }

    render() {
        const {
            startDateError,
            endDateError
        } = this.state;

        const {
            isRequired,
            required,
            ...rest
        } = this.props;

        return (
            <DateRangePickerActual
                {...rest}
                required={isRequired || required}
                startDateError={startDateError}
                endDateError={endDateError} />
        )
    }
}